import { useEffect } from "react";
import { X } from "lucide-react";
import { text } from "../data/content";
import QuoteForm from "./QuoteForm";

export default function QuoteModal({ open, language, selectedProductId, onClose }) {
  useEffect(() => {
    if (!open) return undefined;
    const closeOnEscape = (event) => event.key === "Escape" && onClose();
    document.body.classList.add("modal-open");
    document.addEventListener("keydown", closeOnEscape);
    return () => {
      document.body.classList.remove("modal-open");
      document.removeEventListener("keydown", closeOnEscape);
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="modal-backdrop" role="presentation" onMouseDown={(event) => event.target === event.currentTarget && onClose()} data-testid="quote-modal-backdrop">
      <section className="modal-card" role="dialog" aria-modal="true" aria-labelledby="quote-modal-title" data-testid="quote-modal">
        <div className="modal-head">
          <div>
            <span className="eyebrow">RFQ / 01</span>
            <h2 id="quote-modal-title">{text(language, "اطلب عرض سعر", "Request a quote")}</h2>
            <p>{text(language, "أرسل التفاصيل الأساسية، وسنكمل الحوار عبر WhatsApp.", "Share the essentials and continue the conversation in WhatsApp.")}</p>
          </div>
          <button type="button" className="icon-button" onClick={onClose} aria-label={text(language, "إغلاق النموذج", "Close form")} data-testid="quote-modal-close"><X size={20} /></button>
        </div>
        <QuoteForm language={language} selectedProductId={selectedProductId} />
      </section>
    </div>
  );
}
